<div class="form-container service-form ms-large-y" #formContainer>
  <!-- Initial form state -->
  <form
    *ngIf="formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR"
    [formGroup]="reactiveForm"
    (ngSubmit)="onSubmit()"
    [finFormErrorFocus]="reactiveForm"
  >
    <div *ngIf="formStatus === FormStatus.ERROR">
      <fin-form-error [errorText]="'SERVICE_FORMS.serviceForms.error.title' | finLocalization"></fin-form-error>
    </div>
    <p class="font-body-1 mr-medium-b nordic-blue-900-text">
      {{ 'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization }}
    </p>
    <h3>{{ 'SERVICE_FORMS.serviceForms.titles.yourPersonalDetails' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.PASSENGER_NAME"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.passengerName'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.MEMBER_NUMBER"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.memberNumber'"
        [isSensitive]="true"
      ></fcom-text-input>
    </div>
    <h3>{{ 'SERVICE_FORMS.serviceForms.titles.flightDetails' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-select-input
        *ngIf="!selectedAirlineCode"
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.AIRLINE"
        [options]="airlines"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.airline'"
      >
      </fin-select-input>
      <fcom-text-input
        data-testid="logged-out-missing-points-ticket-number"
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.TICKET_NUMBER"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.ticketNumber.placeHolder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ticketNumber'"
        [isSensitive]="true"
        [useCustomTooltipAction]="true"
        (tooltipClicked)="showHelp($event)"
      ></fcom-text-input>
      <fin-select-input
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.BOOKING_CLASS"
        [options]="bookingClasses"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bookingClass'"
      >
      </fin-select-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-locations-autocomplete
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.FLIGHT_FROM"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.origin'"
        [inputType]="'text'"
        [options$]="departureLocations$"
        [loading$]="departureLoading$"
        [theme]="AutocompleteTheme.WEB_2"
      ></fin-locations-autocomplete>
      <fin-locations-autocomplete
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.FLIGHT_TO"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.destination'"
        [inputType]="'text'"
        [options$]="destinationLocations$"
        [loading$]="destinationLoading$"
        [theme]="AutocompleteTheme.WEB_2"
      ></fin-locations-autocomplete>
      <fin-datepicker
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.DEPARTURE_DATE"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.departureDate.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.missingPointsDepartureDate'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [theme]="DatepickerTheme.WEB_2"
      ></fin-datepicker>
      <fin-datepicker
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.RETURN_DATE"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.returnDate.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.missingPointsReturnDate'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [theme]="DatepickerTheme.WEB_2"
      ></fin-datepicker>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-form-array
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.FLIGHT_NUMBERS"
        [formGroupConfig]="flightNumberFormGroupConfig"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.flightNumber'"
        [minGroups]="1"
        [maxGroups]="6"
      >
        <!-- Numbering for companions should start from 2. FormArray returns 0 index so that is why +2 is added here -->
        <ng-template let-parentFlightNumber="parentFormGroup" let-index="index">
          <div class="flex flex--row flex--wrap form-subgroup">
            <fcom-text-input
              [attr.data-testid]="'logged-out-missing-points-flight-number-' + index"
              [parentForm]="parentFlightNumber"
              [controlName]="LoggedOutMissingPointsFormField.FLIGHT_NUMBER"
              [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.flightNumber'"
              [id]="'flightNumber_' + (index + 2)"
            ></fcom-text-input>
          </div>
        </ng-template>
      </fin-form-array>
    </div>

    <h3>{{ 'SERVICE_FORMS.serviceForms.titles.travelCompanions' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-form-array
        data-testid="logged-out-missing-points-companions"
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.COMPANIONS"
        [formGroupConfig]="companionFormGroupConfig"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.companions'"
        [maxGroups]="10"
      >
        <!-- Numbering for companions should start from 2. FormArray returns 0 index so that is why +2 is added here -->
        <ng-template let-parentCompanion="parentFormGroup" let-index="index">
          <div class="flex flex--row flex--wrap form-subgroup">
            <fcom-text-input
              [parentForm]="parentCompanion"
              [controlName]="LoggedOutMissingPointsFormField.COMPANION_NAME"
              [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.passengerName'"
              [id]="'companion_' + (index + 2) + '_passengerName'"
            ></fcom-text-input>
            <fcom-text-input
              [parentForm]="parentCompanion"
              [controlName]="LoggedOutMissingPointsFormField.COMPANION_MEMBER_NUMBER"
              [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.memberNumber'"
              [isSensitive]="true"
              [id]="'companion_' + (index + 2) + '_memberNumber'"
            ></fcom-text-input>
          </div>
        </ng-template>
      </fin-form-array>
    </div>

    <h3>{{ 'SERVICE_FORMS.serviceForms.titles.yourMessage' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        #message
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.MESSAGE"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.message'"
        [characterLimit]="textareaLimit3000"
        [characterCount]="characterCount"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.EMAIL"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.email'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="LoggedOutMissingPointsFormField.PHONE"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.phoneNumber'"
        [isSensitive]="true"
      ></fcom-text-input>
    </div>

    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-file-uploader
        class="mr-large-b"
        id="logged-out-missing-points-attachment"
        [allowedFileTypes]="allowedFileTypes"
        [controlName]="LoggedOutMissingPointsFormField.ATTACHMENT"
        [i18n]="'SERVICE_FORMS.serviceForms.fields.fileUploader' | finLocalization"
        [maxAttachments]="maxAttachments"
        [maxSizeInBytes]="maxSizeInBytes"
        [parentForm]="reactiveForm"
        #fileUploader
      ></fcom-file-uploader>
    </div>

    <div class="ps-small-t align-right">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.submit' | finLocalization"
      ></fcom-button>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success view -->
  <div *ngIf="formStatus === FormStatus.COMPLETE">
    <h2>{{ 'SERVICE_FORMS.serviceForms.success.title' | finLocalization }}</h2>
  </div>
</div>

<fcom-modal
  [title]="'SERVICE_FORMS.serviceForms.missingPoints.ticketNumberHelpTitle' | finLocalization"
  [(open)]="ticketNumberHelpModalOpen"
  [buttons]="ModalButtons.CLOSE"
>
  <div class="pr-medium">
    <cms-unstyled-fragment
      *ngIf="'fragments.missingPointsTicketNumberHelpModal.url' | finLocalization"
      class="block font-body-1 unstyled-fragment-line-height pr-medium-b help-modal"
      [contentUrl$]="'fragments.missingPointsTicketNumberHelpModal.url' | finLocalization | finToObservable"
    >
    </cms-unstyled-fragment>
  </div>
</fcom-modal>
